import Entity from '../../utilities/entity';

class TrainingSessionLessonContent extends Entity {

}

export default new TrainingSessionLessonContent();